import Vue from 'vue'
import AscGridDrillDownReadCell from '@/components/molecules/AscGridDrillDownReadCell'

export default Vue.extend({
  components: {
    AscGridDrillDownReadCell,
  },

  data: function () {
    return {}
  },

  computed: {
    getDataValue() {
      return this.params.value
    },
    getLocalStorageName() {
      return this.params.localStorageName
    },
    getUpdateDate() {
      return this.params.data[this.params.updateDateFieldName]
    },
  },

  template: `<asc-grid-drill-down-read-cell 
  :value="getDataValue" 
  :update-date="getUpdateDate" 
  :local-storage-name="getLocalStorageName" />`,
})
